import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { numberSetService, type CustomerNumberSet } from '../services/numberSetService'

const NumberSetPage: React.FC = () => {
  const navigate = useNavigate()
  const [numberSets, setNumberSets] = useState<CustomerNumberSet[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const loadList = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const list = await numberSetService.list()
      setNumberSets(list)
    } catch (e) {
      const msg = e instanceof Error ? e.message : 'โหลดรายการไม่สำเร็จ'
      const friendly =
        msg === 'Not Found' || msg.toLowerCase().includes('not found')
          ? 'ยังไม่มีเลขชุด หรือไม่สามารถโหลดรายการได้ในขณะนี้ กรุณากด "สร้างเลขชุด" หรือ "จับวินเลข" เพื่อเพิ่ม'
          : msg
      setError(friendly)
      setNumberSets([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadList()
  }, [loadList])

  const handleCreateNumberSet = () => {
    navigate('/number-set/create')
  }

  const handleWinNumber = () => {
    navigate('/number-set/win-number')
  }

  const handleEditNumberSet = (id: string) => {
    navigate(`/number-set/edit/${id}`)
  }

  const formatDate = (dateStr: string) => {
    try {
      const d = new Date(dateStr)
      return d.toLocaleDateString('th-TH', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
    } catch {
      return dateStr
    }
  }

  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <a
                      href="#"
                      className="txt-link-d"
                      onClick={(e) => {
                        e.preventDefault()
                        navigate('/dashboard')
                      }}
                    >
                      <i className="fas fa-chevron-left me-1"></i>
                      หน้าหลัก
                    </a>
                  </div>
                </div>

                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-7">
                    <div className="wrap justify-content-between bdr-5 bgc-4 px-2 py-1 mb-2">
                      <div className="fs-18 t-medium c-red">
                        <i className="fas fa-inbox me-2"></i>
                        จัดการเลขชุด
                      </div>

                    </div>

                    <div className="row mx--1 mb-2" style={{ rowGap: '0.5rem' }}>
                      <div className="col-12 col-md-6 px-1">
                        <a
                          href="#"
                          className="check-button bgg-4 c-white w-100 d-block text-center"
                          onClick={(e) => {
                            e.preventDefault()
                            handleCreateNumberSet()
                          }}
                        >
                          <p className="">
                            <i className="fas fa-plus me-1"></i>
                            สร้างเลขชุด
                          </p>
                        </a>
                      </div>
                      <div className="col-12 col-md-6 px-1">
                        <a
                          href="#"
                          className="check-button bgc-3 c-white w-100 d-block text-center"
                          onClick={(e) => {
                            e.preventDefault()
                            handleWinNumber()
                          }}
                        >
                          <p className="">
                            <i className="fas fa-random me-1"></i>
                            จับวินเลข
                          </p>
                        </a>
                      </div>
                    </div>

                    <div className="bdr-5 bgc-4 c-red p-2">
                      {error && (
                        <div className="mb-2 p-2 bdr-5 bgc-7 c-red">
                          {error}
                        </div>
                      )}
                      {loading ? (
                        <div className="text-center py-4">
                          <i className="fas fa-spinner fa-spin fs-24 c-dark"></i>
                          <p className="c-dark mt-2">กำลังโหลด...</p>
                        </div>
                      ) : (
                        <div className="row gap-2 mx--1">
                          {numberSets.length === 0 ? (
                            <div className="col-12 px-1 text-center py-4 c-dark" style={{ fontSize: '1rem' }}>
                              ยังไม่มีเลขชุด กรุณากดปุ่ม &quot;สร้างเลขชุด&quot; หรือ &quot;จับวินเลข&quot; ด้านบนเพื่อเพิ่มเลขชุดใหม่
                            </div>
                          ) : (
                            numberSets.map((numberSet) => (
                              <div key={numberSet._id} className="col-12 px-1">
                                <a
                                  href="#"
                                  className="check-button px-2 text-start bdc-1 c-dark w-100 box-hover d-block"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    handleEditNumberSet(numberSet._id)
                                  }}
                                >
                                  <h6 className="t-medium">{numberSet.name}</h6>
                                  <small className="">
                                    {formatDate(numberSet.updatedAt || numberSet.createdAt)}
                                  </small>
                                </a>
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NumberSetPage
